import { render, staticRenderFns } from "./entity-document-folder.vue?vue&type=template&id=53ea44e8&scoped=true"
import script from "./entity-document-folder.vue?vue&type=script&lang=js"
export * from "./entity-document-folder.vue?vue&type=script&lang=js"
import style0 from "./entity-document-folder.vue?vue&type=style&index=0&id=53ea44e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ea44e8",
  null
  
)

export default component.exports